import { useDispatch } from "react-redux";
import { fetchLegacyUserFailure } from "redux/auth/actions";
import { Grid } from "@material-ui/core";
import { Layout, SrButton, Typography } from "components/common";
import Footer from "components/Footer/Footer";
import Header from "components/modules/Auth/Header";
import { FormattedMessage } from "react-intl";
import { View } from "components/utils";

const Error = () => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(fetchLegacyUserFailure(null));
  };

  return (
    <Layout
      header={<Header />}
      content={
        <View translateTitleKey="failToLoad.title">
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="space-beetwen"
            spacing={8}
          >
            <Grid item xs={12}>
              <Typography variant="h2">
                <FormattedMessage id="failToLoad.title" />
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <SrButton color="primary" variant="contained" onClick={onClick}>
                <FormattedMessage id="failToLoad.homeButton" />
              </SrButton>
            </Grid>
          </Grid>
        </View>
      }
      footer={<Footer />}
    />
  );
};

export default Error;
